var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section4"}},[_c('ty',{attrs:{"titles":_vm.p17s5titles,"videos":_vm.p17s5videos,"activo":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }